import { createVar, fallbackVar } from '@vanilla-extract/css';
import { themeVars } from '../theme/vars';
import { borderRadius, space } from '../tokens';
import { typography } from '../typography';
import { style, styleVariants } from '../layer.css';

export const tabNavIndicatorWidth = 100;

export const stickyTabNavVar = createVar();

export const stickyBar = style({
  position: 'sticky',
  top: 0,
  zIndex: 1,
  backgroundColor: themeVars.base.background,

  '::before': {
    content: '',
    display: 'block',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    boxShadow: `inset 0 -1px ${themeVars.controls.border.default}`,
    zIndex: -1,
    transition: 'all .2s',
    backgroundColor: themeVars.base.background,
  },

  selectors: {
    [`&[data-sticky]::before`]: {
      right: fallbackVar(stickyTabNavVar, '-10vw'),
      left: fallbackVar(stickyTabNavVar, '-10vw'),
    },
  },
});

export const tabNavList = style({
  position: 'relative',
  display: 'flex',
  scrollbarWidth: 'none',
  overflowX: 'auto',
  boxShadow: `inset 0 -1px ${themeVars.color.border.tertiary}`,
  margin: 0,
  padding: 0,
  height: '100%',
  isolation: 'isolate',

  selectors: {
    [`${stickyBar} &`]: {
      boxShadow: 'none',
    },
  },
});

export const tabNavListNoBorder = style({
  boxShadow: 'none',
});

export const tabNavListSize = styleVariants({
  small: {},
  large: {},
});

export const tabNavItem = style({
  listStyle: 'none',
  flexShrink: 0,

  selectors: {
    [`${tabNavListSize.small} &`]: {
      minHeight: 30,
    },
    [`${tabNavListSize.large} &`]: {
      minHeight: 52,
    },
  },
});

export const tabNavLink = style([
  {
    display: 'flex',
    alignItems: 'flex-start',
    color: themeVars.tab.foreground.default,
    height: '100%',

    ':hover': {
      color: themeVars.tab.foreground.hover,
    },

    selectors: {
      '&[data-active]': {
        color: themeVars.tab.foreground.active,
      },

      [`${tabNavListSize.small} &`]: {
        ...typography['labelMd'],
        padding: `0 ${space.s12}px`,
      },
      [`${tabNavListSize.large} &`]: {
        ...typography['labelLg'],
        padding: `11px ${space.s8}px 0 ${space.s8}px`,
      },
    },
  },
]);

export const tabNavItemContent = style({
  padding: `0 ${space.s4}px`,
  display: 'inline-flex',
  gap: space.s4,
  alignItems: 'center',
  justifyContent: 'center',
});

export const tabNavIndicator = style({
  display: 'none',
  position: 'absolute',
  left: 0,
  bottom: '1px',
  height: '4px',
  backgroundColor: themeVars.tab.border.active,
  borderRadius: `${borderRadius.r8}px ${borderRadius.r8}px 0 0`,
  width: tabNavIndicatorWidth,
});

export const tabNavIndicatorMounted = style({
  willChange: 'transition',
  transition: 'transform 150ms',
  transformOrigin: 0,

  selectors: {
    [`${tabNavList}:has([data-active]) &`]: {
      display: 'block',
    },
  },
});
